import { useQuery } from 'react-query';

import { api } from '../api';

export interface ITransactions {
  idOrdemRepasse: string;
  status: number;
  dtMovimento: string;
  numOrdem: number;
  serie: string;
  parcela: string;
  dtPrevPgto: string;
  vlParcela: number;
  vlTxAdm: number;
  vlTxAnt: number;
  vlLocacao: number;
  vlOutrosDesc: number;
  vlLiquido: number;
  produtoId: number;
  produtoDescricao: string;
  vlAberto: number;
  bandeira: string;
  dtPgto: string | null;
  vlPgto: number;
  estabFantasia: string;
  estabDocto: string;
}

interface IParams {
  docto: string;
  dtInicial: string;
  dtFinal: string;
  pagina: number;
  limite: number;
  tipoPeriodo: string;
  situacao: string;
  bandeira: string;
  tipoProd: string;
}

interface GetRelatorioPagamentoResult {
  transactions: ITransactions[];
  total: number;
}

export async function getRelatorioPagamento(
  params: IParams
): Promise<GetRelatorioPagamentoResult> {
  if (params.docto !== '') {
    const { data } = await api.get('transactions/ordem-repasse', {
      params,
    });

    return { transactions: data, total: data.length };
  }

  return { transactions: [], total: 0 };
}

export function useRelatorioPagamento(params: IParams) {
  return useQuery(
    [
      'relatorio-pagamento',
      params.docto,
      params.dtInicial,
      params.dtFinal,
      params.pagina,
      params.limite,
      params.tipoPeriodo,
      params.situacao,
      params.bandeira,
      params.tipoProd,
    ],
    () => getRelatorioPagamento(params),
    {
      staleTime: Infinity,
      enabled: String(api.defaults.headers.common.authorization).length > 10 && !!params.docto,
      retry: 2
    }
  );
}
